import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControl,
    InputAdornment,
    InputLabel,
    IconButton,
    MenuItem,
    Select,
    TextField,
    Box,
    CircularProgress,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { path } from "../../../routes";

const AddUser_modal = (props) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [selectedOrg, setSelectedOrg] = useState(props.orgId || "");
    const [orgList, setOrgList] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getOrganizations();
        if (props.orgId) {
            setSelectedOrg(props.orgId);
        }
    }, [props.orgId]);

    const getOrganizations = async () => {
        try {
            let response = await axios.get(`${path}/getOrganizations`);
            setOrgList(response.data);
        } catch (error) {
            console.error("Error fetching organizations:", error);
        }
    };

    const handleUsernameChange = (event) => {
        setUsername(event.target.value);
    };

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    };

    const handleOrgChange = (event) => {
        setSelectedOrg(event.target.value);
    };

    const close_handler = () => {
        props.close();
    };

    const handleSubmit = async () => {
        if (!username.trim() || !password.trim() || !selectedOrg) {
            alert("Please fill in all required fields");
            return;
        }

        setLoading(true);
        try {
            await axios.post(`${path}/addnewuser`, {
                username: username,
                password: password,
                organization: selectedOrg,
            });

            alert("User uložen úspěšně");
            props.close();
        } catch (error) {
            console.error("Error uploading user:", error);
            alert("Error uploading user");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={true}
            onClose={close_handler}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: { xs: 0, sm: "12px" },
                    maxHeight: { xs: "100vh", sm: "90vh" },
                    margin: { xs: 0, sm: "32px" },
                    width: { xs: "100%", sm: "auto" },
                },
            }}
        >
            <DialogTitle
                sx={{
                    fontSize: { xs: "18px", sm: "20px" },
                    fontWeight: 600,
                    pb: 1.5,
                    borderBottom: "1px solid #e0e0e0",
                }}
            >
                Add User
            </DialogTitle>

            <DialogContent
                sx={{
                    pt: 3,
                    pb: 3,
                    px: { xs: 2, sm: 3 },
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        paddingTop: 2,
                    }}
                >
                    <TextField
                        sx={{ width: "100%" }}
                        id="username"
                        label="Username"
                        variant="outlined"
                        value={username}
                        onChange={handleUsernameChange}
                        fullWidth
                        required
                    />
                    <TextField
                        sx={{ width: "100%" }}
                        id="password"
                        label="Password"
                        type={showPassword ? "text" : "password"}
                        variant="outlined"
                        value={password}
                        onChange={handlePasswordChange}
                        fullWidth
                        required
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label={showPassword ? "Skrýt heslo" : "Zobrazit heslo"}
                                        onClick={() => setShowPassword((prev) => !prev)}
                                        onMouseDown={(e) => e.preventDefault()}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                    <FormControl sx={{ width: "100%" }}>
                        <InputLabel id="org-select-label">Select Organization</InputLabel>
                        <Select
                            labelId="org-select-label"
                            value={selectedOrg}
                            label="Select Organization"
                            onChange={handleOrgChange}
                            disabled={!!props.orgId}
                        >
                            {orgList.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </DialogContent>

            <DialogActions
                sx={{
                    px: { xs: 2, sm: 3 },
                    pb: { xs: 2, sm: 2.5 },
                    pt: 2,
                    borderTop: "1px solid #e0e0e0",
                    gap: { xs: 1, sm: 1.5 },
                    flexDirection: { xs: "column", sm: "row" },
                }}
            >
                <Button
                    onClick={close_handler}
                    disabled={loading}
                    variant="outlined"
                    sx={{
                        width: { xs: "100%", sm: "auto" },
                        minWidth: { xs: "100%", sm: 120 },
                        height: { xs: "48px", sm: "auto" },
                        order: { xs: 2, sm: 1 },
                    }}
                >
                    Cancel
                </Button>
                <Button
                    disabled={
                        !username.trim() || !password.trim() || !selectedOrg || loading
                    }
                    onClick={handleSubmit}
                    variant="contained"
                    sx={{
                        width: { xs: "100%", sm: "auto" },
                        minWidth: { xs: "100%", sm: 120 },
                        height: { xs: "48px", sm: "auto" },
                        fontWeight: 600,
                        order: { xs: 1, sm: 2 },
                        boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
                        "&:hover": {
                            boxShadow: "0 6px 16px rgba(25, 118, 210, 0.4)",
                        },
                        "&:disabled": {
                            backgroundColor: "#e0e0e0",
                            color: "#9e9e9e",
                        },
                    }}
                >
                    {loading ? (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <CircularProgress size={20} color="inherit" />
                            <span>Saving...</span>
                        </Box>
                    ) : (
                        "Save"
                    )}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddUser_modal;
